import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Link, SidebarModal } from '@domain-group/suit-theme'

import usePriorityCampaign from '@hooks/usePriorityCampaign'
import useUser, { useRelations } from '@hooks/useUser'

import type { PriorityCampaignModel } from '@models/types'

import { confirmDelete } from '@functions/entity'

interface PriorityCampaignUserListItemProps {
  priorityCampaign: PriorityCampaignModel,
}

const PriorityCampaignUserListItem = (props: PriorityCampaignUserListItemProps) => {
  const {
    priorityCampaign,
  } = props

  const priorityCampaignPayload = usePriorityCampaign(priorityCampaign)
  const {
    callbacks: { deletePriorityCampaign: deleteFn },
    priorityCampaign: { owner_id: userId },
  } = priorityCampaignPayload

  const userPayload = useUser({ id: userId })
  const { user } = userPayload

  const { image } = useRelations(user)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This will remove the priority status of this campaign for the user.',
      deleteString: 'Remove',
      entityName: 'User',
    },
  }

  return (
    <SidebarModal.User
      disableHover
      // @ts-expect-error TS2339
      imageUrl={image.square_url}
      subtitle={user.mobile_number}
      title={user.title}
    >
      <Link
        greyLink
        // @ts-expect-error TS2345
        onClick={() => confirmDelete(confirmDeletePayload)}
        textProps={{ fontSize: 'small' }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </SidebarModal.User>
  )
}

export default PriorityCampaignUserListItem
